import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "../lib/motion";

export const CtaBanner = ({
  title = "Hai un obiettivo in mente? Parliamone insieme.",
  text = "Raccontaci il tuo punto di partenza: ti aiutiamo a individuare il percorso più adatto a te.",
}) => {
  return (
    <section data-testid="cta-banner" className="relative py-20 lg:py-28 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
        <Reveal className="relative bg-navy rounded-[2rem] px-8 py-14 sm:px-14 lg:px-20 lg:py-20 overflow-hidden grain">
          <div className="absolute -top-24 -right-24 w-80 h-80 rounded-full border border-dashed border-sky-400/30 spin-slower" />
          <div className="absolute -bottom-32 -left-20 w-96 h-96 rounded-full bg-azure-veil blur-3xl" />
          <div className="relative max-w-2xl">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white text-balance">
              {title}
            </h2>
            <p className="mt-5 text-base md:text-lg text-white/65 leading-relaxed">
              {text}
            </p>
            <Link
              to="/contatti"
              data-testid="cta-banner-button"
              className="mt-9 inline-flex items-center gap-2.5 rounded-full bg-white px-7 py-3.5 text-sm font-bold text-navy transition-all duration-300 hover:bg-sky-300 hover:-translate-y-0.5 group"
            >
              Richiedi informazioni
              <ArrowRight
                size={17}
                className="transition-transform duration-300 group-hover:translate-x-1"
              />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
